import { useAppSelector } from '@/store/hooks';
import { Message } from './components/Message';
import { ChatMessagesLoading } from './components/ChatMessagesLoading';

interface UserData {
  given_name?: string;
  family_name?: string;
  img?: string;
}

interface ChatMessage {
  id: string;
  content: string;
  created: string;
  sender: string;
  userData?: UserData;
}

interface ProjectChatMessagesProps {
  messages: ChatMessage[] | null;
  isVisible: boolean;
  projectId: string;
  uid: string | null;
  userRole: string | null;
  updateModalOpen: (type: string, params?: Record<string, unknown>) => void;
}

export function ProjectChatMessages({
  messages,
  isVisible,
  projectId,
  uid,
  userRole,
  updateModalOpen,
}: ProjectChatMessagesProps) {
  // Resolve sender from the live users list at render time, falling back to the
  // snapshot stored at transform time — prevents stale "[Removed user]" entries
  const projectUsers = useAppSelector((state) => state.project.users) as Array<{ uid: string } & UserData>;
  const resolveSender = (msg: ChatMessage): UserData | undefined =>
    projectUsers.find((u) => u.uid === msg.sender) ?? msg.userData;

  return (
    <ul className={isVisible ? '' : 'hidden'}>
      {messages ? (
        messages.map((msg) => {
          const sender = resolveSender(msg);
          return (
          <Message
            key={msg.created}
            firstName={sender?.given_name}
            lastName={sender?.family_name}
            created={msg.created}
            content={msg.content}
            image={{ task: false, imageUrl: sender?.img }}
            isAReply={false}
            messageId={msg.id}
            projectId={projectId}
            isRemovable={
              (userRole === 'admin' || uid === msg.sender) && userRole !== 'guest' && !!msg.id
            }
            updateModalOpen={updateModalOpen}
          />
          );
        })
      ) : (
        <ChatMessagesLoading amount={5} />
      )}
    </ul>
  );
}
